@switch (type) {
  @case (NO_RESULTS_TYPES.DEFAULT) {
    <div class="no_results"
         [ngClass]="{ 'ws-wrap': wrap }"
         [innerHTML]="'no_results' | translate: { text: text | truncate:20 } | safeHtml">
    </div>
  }
}
